import React from 'react';

const ArrowUp = ({ fillColor = '#0D8DE7', ...props }) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 6.91251L5 11.9125L6.175 13.0875L10 9.27084L13.825 13.0875L15 11.9125L10 6.91251Z" fill={fillColor} />
  </svg>
);

export default ArrowUp;
